module.exports = __webpack_public_path__ + "static/HauNguyen-c896ce5819da0e02ca8a214cdfb43dfc.svg";